import { action, autorun, computed, decorate, extendObservable } from "mobx";
import moment from "moment/moment";

const DATE_FORMAT = "M/DD/YYYY";

class InvestigationsStore {
  constructor(authStore, commonStore, investigationsApi, loadingStore) {
    this.authStore = authStore;
    this.commonStore = commonStore;
    this.investigationsApi = investigationsApi;
    this.loadingStore = loadingStore;

    this.defaults = {
      reservations: [],
      recipientLastName: null,
      recipientFirstName: null,
      requesterLastName: null,
      requesterFirstName: null,
      deliveryEmail: null,
      deliveryMobilePhone: null,
      selectedOrg: null,
      useDateRange: false
    };

    extendObservable(this, {
      reservations: this.defaults["reservations"],
      recipientLastName: this.defaults["recipientLastName"],
      recipientFirstName: this.defaults["recipientFirstName"],
      requesterLastName: this.defaults["requesterLastName"],
      requesterFirstName: this.defaults["requesterFirstName"],
      deliveryEmail: this.defaults["deliveryEmail"],
      deliveryMobilePhone: this.defaults["deliveryMobilePhone"],
      selectedOrg: this.defaults["selectedOrg"],
      useDateRange: this.defaults["useDateRange"],
      resetStore: action(() => {
        this.reservations = this.defaults["reservations"];
        this.recipientLastName = this.defaults["recipientLastName"];
        this.recipientFirstName = this.defaults["recipientFirstName"];
        this.requesterLastName = this.defaults["requesterLastName"];
        this.requesterFirstName = this.defaults["requesterFirstName"];
        this.deliveryEmail = this.defaults["deliveryEmail"];
        this.deliveryMobilePhone = this.defaults["deliveryMobilePhone"];
        this.selectedOrg = this.defaults["selectedOrg"];
      }),
      setReservations: action(val => {
        this.reservations = val;
      }),
      setRecipientLastName: action(val => {
        this.recipientLastName = val;
      }),
      setRecipientFirstName: action(val => {
        this.recipientFirstName = val;
      }),
      setRequesterFirstName: action(val => {
        this.requesterFirstName = val;
      }),
      setRequesterLastName: action(val => {
        this.requesterLastName = val;
      }),
      setDeliveryEmail: action(val => {
        this.deliveryEmail = val;
      }),
      setDeliveryMobilePhone: action(val => {
        this.deliveryMobilePhone = val;
      }),
      setSelectedOrg: action(val => {
        this.selectedOrg = val;
      }),
      setDateRange: action(val => {
        this.useDateRange = val;
      }),
      searchInvestigation: action(() => {
        this.investigationsApi
          .searchInvestigations(
            this.recipientFirstName,
            this.recipientLastName,
            this.deliveryMobilePhone,
            this.deliveryEmail,
            this.requesterFirstName,
            this.requesterLastName,
            this.selectedOrg?.value,
            this.useDateRange,
            this.commonStore.dateRangeFilter
          )
          .then(data => {
            this.setReservations(data.tickets);
          });
      })
    });

    autorun(() => {
      if (this.authStore.isInvestigations) {
      } else {
        this.resetStore();
      }
    });
  }

  get isValidSearch() {
    return (
      this.requesterFirstName?.trim().length > 3 ||
      this.requesterLastName?.trim().length > 3 ||
      this.recipientFirstName?.trim().length > 3 ||
      this.recipientLastName?.trim().length > 3 ||
      this.deliveryMobilePhone?.trim().length > 0 ||
      this.deliveryEmail?.trim().length > 0 ||
      this.selectedOrg?.value
    );
  }

  investigationReport() {
    this.loadingStore.setLoading(true);

    let start = moment(this.commonStore.dateRangeFilter.start);
    let end = moment(this.commonStore.dateRangeFilter.end);

    this.investigationsApi
      .sendReport({
        requesterLastName: this.requesterLastName,
        requesterFirstName: this.requesterFirstName,
        recipientLastName: this.recipientLastName,
        recipientFirstName: this.recipientFirstName,
        recipientPhone: this.deliveryMobilePhone,
        recipientEmail: this.deliveryEmail,
        selectedOrg: this.selectedOrg?.value,
        dateRange: this.commonStore.dateRangeFilter,
        useDateRange: this.useDateRange,
        orgId: this.selectedOrg?.value,
        startDate: start.format(DATE_FORMAT),
        endDate: end.format(DATE_FORMAT)
      })
      .then(response => {
        this.downloadLink(response, "application/vnd.ms-excel");
        this.loadingStore.setLoading(false);
      });
  }
  downloadLink(response, type) {
    let blob = new Blob([response.data], { type: type });

    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
      window.navigator.msSaveOrOpenBlob(blob, response.headers["report-title"]);
      return;
    }
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", response.headers["report-title"]);
    document.body.appendChild(link);
    link.click();
    setTimeout(function() {
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }, 1000);
  }
}

decorate(InvestigationsStore, {
  isValidSearch: computed
});

export default InvestigationsStore;
